/*eslint-env browser*/

let Sound
let mute
let sounds = {}
let toBePlayedAfterLoad = {}



function use (Adapter) {
    Sound = Adapter
    Sound.setup(onloadCallback)
}



function init (filePaths) {
    filePaths = filePaths || {}
    setSounds(filePaths)
    setMute(JSON.parse(localStorage.getItem("mute")) || false)
}



function destroySounds () {
    for (let name in sounds) {
        sounds[name].unload()
        delete sounds[name]
    }
}



function setSounds (filePaths) {
    destroySounds()

    for (let name in filePaths) {
        setSound(name, filePaths[name])
    }
}



function setSound (name, filePath) {
    sounds[name] = new Sound({
        sounds,
        name,
        url:    filePath
    })
}


function getSound (name) {
    return sounds[name]
}


let allSoundsLoadedCallbacksWaiting = []

function onloadCallback (name) {
    if (allSoundsLoadedCallbacksWaiting.length > 0) {
        if (allSoundsLoaded()) {
            allSoundsLoadedCallbacksWaiting.forEach(callback => callback())
            allSoundsLoadedCallbacksWaiting = []
        }
    }
    if (toBePlayedAfterLoad[name]) {
        play(name)
    }
}


function allSoundsLoaded () {
    for (let name in sounds) {
        if (!sounds[name].loaded()) {
            return false
        }
    }
    return true
}


//TODO allow for several calls of this (use event capabilities ?)
function onAllSoundsLoaded (callback) {
    if (allSoundsLoaded()) {
        callback()
    } else {
        allSoundsLoadedCallbacksWaiting.push(callback)
    }
}


// @FIXME function name
function setLoop (name, callback) {
    sounds[name].loop(true, callback)
}



function play (name, params) {
    let sound = sounds[name]

    if (!sound || !sound.loaded()) {
        toBePlayedAfterLoad[name] = true
        return
    }

    sound.play(params)
}



function stop (name) {
    if (name) {
        stopOne(name)
    } else {
        stopAll()
    }
}



function stopOne (name) {
    if (sounds[name].loaded()) {
        sounds[name].stop()
    } else {
        delete toBePlayedAfterLoad[name]
    }
}


function stopAll () {
    for (let name in sounds) {
        stopOne(name)
    }
}



function toggleMute () {
    setMute(!mute)
}



function setMute (state) {
    mute = state
    localStorage.mute = mute

    Sound.globalVolume(mute ? 0 : 1)
}



function setVolume (volumeRatio) {
    Sound.globalVolume(volumeRatio)
}



function setFadeDuration (fadeDuration) {
    Sound.setFadeDuration(fadeDuration)
}



function isMute () {
    return mute
}


function duration (name) {
    let sound = sounds[name]
    return (sound ? sound.duration : 0)
}


function volume (name) {
    let sound = sounds[name]
    return (sound ? sound.volume() : 0)
}



export default {
    use,
    toggleMute,
    setMute,
    stop,
    init,
    setSound,
    getSound,
    setLoop,
    setFadeDuration,
    play,
    isMute,
    onAllSoundsLoaded,
    duration,
    volume,
    setVolume
}


